export default {
  // Page titles
  title: "المدن",
  
  // Create page
  create: {
    title: "إنشاء مدينة",
  },
  
  // Edit page
  edit: {
    title: "تعديل مدينة",
  },
  
  // Fields
  fields: {
    id: "المعرف",
    name: "الاسم",
    country: "الدولة",
    localDeliveryFee: "رسوم التوصيل المحلي",
  },
  
  // Actions
  actions: {
    create: "إنشاء مدينة",
    update: "تحديث مدينة",
    delete: "حذف",
    edit: "تعديل",
    view: "عرض",
    title: "خيارات الأوامر",
    cancel:"إلغاء"
  },
  
  // Placeholders
  placeholders: {
    search: "البحث في المدن...",
    enterName: "أدخل اسم المدينة",
    selectCountry: "اختر الدولة",
    enterLocalDeliveryFee: "أدخل رسوم التوصيل المحلي",
  },
  
  // Validation
  validation: {
    nameRequired: "اسم المدينة مطلوب",
    countryRequired: "الدولة مطلوبة",
  },
  
  // Messages
  messages: {
    createSuccess: "تم إنشاء المدينة بنجاح",
    createError: "فشل في إنشاء المدينة",
    updateSuccess: "تم تحديث المدينة بنجاح",
    updateError: "فشل في تحديث المدينة",
    deleteSuccess: "تم حذف المدينة بنجاح",
    deleteError: "فشل في حذف المدينة",
    deleteConfirm: "هل أنت متأكد من حذف هذه المدينة؟",
    fetchError: "فشل في جلب المدن",
    fetchCountriesError: "فشل في جلب الدول",
    noCities: "لا توجد مدن",
    loading: "جاري تحميل المدن...",
  },
};
